export default "__VITE_ASSET__de413bc6__"